import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { App, AppInfo } from '@capacitor/app';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {

  public appID: string;

  constructor(
      public platform: Platform
  ) { }

  setAppInfo() {
    if (this.platform.is("cordova")) {
      App.getInfo().then(appInfo => {
        // If the app is running on Android and is running default 1Rink app, set the appID to the default app ID
        if (this.platform.is("android") && appInfo.id == environment.ANDROID_DEFAULT_APP_ID) {
          this.appID = environment.DEFUALT_APP_ID;
        } else {
          this.appID = appInfo.id;
        }
      });
    } else {
      this.appID = environment.DEFUALT_APP_ID;
    }
  }
}
